import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export default function NavBlueBar(_ref) {
  var className = _ref.className,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("nav", {
      "aria-label": label,
      className: "jsx-3863554442" + " " + (className || ""),
      children: /*#__PURE__*/_jsx("div", {
        className: "jsx-3863554442" + " " + 'inner',
        children: children
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3863554442",
      children: ["nav.jsx-3863554442{position:relative;border-bottom:5px solid white;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,0.5);box-shadow:0 2px 4px 0 rgba(0,0,0,0.5);}", "nav.jsx-3863554442::after{content:'';display:block;height:8px;background:white;border-bottom:3px solid #21409A;}", ".inner.jsx-3863554442{background:-webkit-gradient(linear,left top,left bottom,from(#21409A),color-stop(90%,#0F0D3D));background:linear-gradient(#21409A 0%,#0F0D3D 90%);padding-left:calc(var(--headerLogoWidth) + var(--headerLogoOffsetLeft) + var(--headerLogoPaddingLeft));}"]
    })]
  });
}